var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('carousel',{class:[
        (_vm.navigationEnabled == 'hide') ? 'navigation-hide' : '',
        (_vm.paginationEnabled == 'hide') ? 'pagination-hide' : '',
        _vm.addClass
    ],attrs:{"id":_vm.id,"navigationEnabled":true,"paginationEnabled":true,"perPage":parseInt(_vm.slidesPerPage),"loop":_vm.loop == 'true' ? true : false,"autoplay":_vm.autoplay == 'true' ? true : false,"autoplayTimeout":_vm.timeout ? parseInt(_vm.timeout) : 2000,"autoplayDirection":_vm.sliderDirection ? _vm.sliderDirection : 'forward',"controls":true,"indicators":true}},[_vm._l((parseInt(_vm.slidesCount)),function(index){return _vm._t(("slide-" + (parseInt(index) - 1)))})],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-929ff854","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Resources/assets/js/UI/components/carousel.vue
// module id = YhbL
// module chunks = 0